/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的平台会员卡和会员权益
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.MemberEquitiesDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/equities`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
